// src/componets/ForexHeatmap.js
import React, { useEffect, useRef, memo } from 'react';

function ForexHeatmap() {
  const container = useRef();

  useEffect(
    () => {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-forex-heat-map.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "colorTheme": "dark",
          "isTransparent": false,
          "locale": "en",
          "currencies": [
            "EUR",
            "USD",
            "JPY",
            "GBP",
            "CHF",
            "AUD",
            "CAD",
            "NZD",
            "CNY",
            "ZAR",
            "TRY",
            "NOK",
            "SEK",
            "DKK",
            "HKD",
            "SGD",
            "MXN",
            "THB",
            "IDR",
            "KRW",
            "ISK",
            "PLN",
            "KWD",
            "AED",
            "ILS",
            "RUB",
            "ARS",
            "CLP",
            "PEN",
            "COP",
            "UYU"
          ],
          "backgroundColor": "#0F0F0F",
          "width": "100%",
          "height": "100%"
        }`;
      
      let currentContainer = container.current;

      if (currentContainer) {
        const timeoutId = setTimeout(() => {
          currentContainer.appendChild(script);
        }, 100);

        return () => {
          clearTimeout(timeoutId);
          if (currentContainer) {
            currentContainer.innerHTML = "";
          }
        };
      }

      return () => {
        if (currentContainer) {
          currentContainer.innerHTML = "";
        }
      };
    }, []
  );

  return (
    <div className="tradingview-widget-container" ref={container}>
    </div>
  );
}

export default memo(ForexHeatmap);
